import { intl } from '../../../../../../../../../i18n'
import { TicketListSelect } from '../../../../TicketListSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  PageTitleSection,
  FormSection,
  FormLabel,
  PageTitleInput,
} from '../styles'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

type ProgressReportByTicketListConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

/** チケット管理表別進捗状況の設定。行にするチケット管理表を選ぶ（選んだ順に行が並ぶ） */
export const ProgressReportByTicketListConfigForm = ({
  page,
  snapshotUuid,
  onUpdate,
}: ProgressReportByTicketListConfigFormProps) => {
  const { handlePageTitleChange, handleTableRowsChange } =
    usePageConfigHandlers(page, onUpdate)

  return (
    <ConfigContainer>
      <PageTitleSection>
        <PageTitleInput
          label={intl.formatMessage({
            id: 'versionReport.pageConfig.pageTitle',
          })}
          value={page.pageTitle}
          onChange={handlePageTitleChange}
          placeholder={intl.formatMessage({
            id: 'versionReport.pageConfig.pageTitle.placeholder',
          })}
          variant="outlined"
          required={true}
        />
      </PageTitleSection>
      <SectionContent>
        <FormSection>
          <FormLabel>
            {intl.formatMessage({
              id: 'versionReport.pageConfig.ticketLists',
            })}
          </FormLabel>
          <TicketListSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={page.config.tableRows}
            onChange={handleTableRowsChange}
            isMultiSelect={true}
            // 行にする管理表を選ぶことがこの設定の主目的で、畳む意味がない。
            // 常に開いたままにして「変更する」ボタンも出さない
            alwaysOpen={true}
          />
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
